<template>
    <div>
        <ClientsListTable 
            :clientsList="clientsList"
            :loadingState="loadingState"
            :loadingText="loadingText"
            :showAllClients="true"
            @add-client="openAddClientModal"
        />
        <AddClientModal 
            :isOpen="showAddClientModal"
            @closed="showAddClientModal = false"
            @client-created="onClientCreated"
        />
    </div>
</template>

<script>
import ClientsListTable from '@/components/Clients/ClientsListTable'
import AddClientModal from '@/components/Clients/AddClientModal'

    export default {
        components: {
            ClientsListTable,
            AddClientModal
        },
        data() {
            return {
                clientsList: [],
                loadingState: true,
                loadingText: 'Loading Clients...',
                showAddClientModal: false,
            }
        },
        created() {
            this.$root.$emit('SET_PAGE_TITLE', this.$route.meta.title);
            this.$root.$emit('SET_PAGE_TITLE_BADGES', []);
        },
        mounted() {
            this.getActiveClients();
        },
        methods: {
            getActiveClients: function() {
                const hostUrl = this.$config.aimsAPI;

                this.$http.get(`${hostUrl}clients/all`).then(
                    (response) => {
                        this.clientsList = response.data;
                        this.loadingState = false;
                    },
                    (error) => {
                        this.showError('Error fetching active clients list', error);
                        console.error(error);
                    }
                );
            },
            openAddClientModal: function() {
                this.showAddClientModal = true;
            },
            onClientCreated: function(clientNumber) {
                this.getActiveClients();
            }
        }
    }
</script>